import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { borderColor, focusOutline, textColor } from '../../Resources/CSS/styling';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const useTabs = (tabPassed) => {
    const [tabs, setTabs] = useState(tabPassed);

    const setCurrentTab = (tab) => {
        setTabs(tabs.map(t => ({ ...t, current: t.name === tab.name })));
    }

    const currentTab = tabs.find(t => t.current);

    useEffect(() => {
        if (!currentTab && tabs.length > 0) {
            tabs[0].current = true;
            setTabs(tabs);
        }
    }, [tabs]);

    return {
        tabs,
        setTabs,
        currentTab: tabs.find(t => t.current),
        currentTabIndex: tabs.findIndex(t => t.current),
        setCurrentTab
    }
}

export default function SegmentControl(props) {

  const { tabs, setTabs, currentTab, setCurrentTab } = props.tabs;

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:hidden">
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          onChange={(e) => setCurrentTab(tabs.find(tab => tab.name === e.target.value))}
          defaultValue={currentTab?.name}
          aria-label="Select a tab"
          className={`col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 ${focusOutline}`}
        >
          {tabs && tabs.map((tab) => (
            <option value={tab.name} key={tab.name}>{tab.name}</option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
        />
      </div>
      <div className="hidden sm:block w-full">
        <div className="flex flex-row w-full">
          <nav aria-label="Tabs" className="-mb-px flex w-full bg-gray-100 px-2 py-1 rounded-md">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => setCurrentTab(tab)}
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.current
                    ? `bg-white rounded-md border border-gray-200 text-gray-900 font-bold`
                    : 'bg-gray-100 rounded-md text-gray-500 font-medium',
                  'group inline-flex items-center flex-1 justify-center py-2 text-sm cursor-pointer',
                )}
              >
                
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}
